<template>
	<div class="bottom">
		<div class="con">
			<div class="tit">尚时总部地址：江阴市人民东路1091号，佳兆业广场7楼 (214400)</div>
			<div>Headquarters Address: 7 Floor,Kaisa (Jia Zhao Ye) Square,1091 Renmin East Road,Jiangyin,JiangSu,China.</div>
			<div>Postcode: 214400</div>
		</div>
		<div class="bord"></div>
		<div class="con">
			<div class="tit">尚时制造基地地址：江阴市徐霞客镇峭岐博爱路58号 (214400) </div>
			<div>Manufactory Base Address: 58 Boai Road,Qiaoqi,Xiake Town,Jiangyin,Jiangsu,China.</div>
			<div>Postcode: 214400</div>
		</div>
		<div class="bord"></div>
		<div class="con">
			<div class="tit tel">Tel:0086-510-86692066</div>
			<div>周一至周五（8:00-16:30）</div>
			<div>Worktime: Monday to Friday (8:00-16:30）</div>
			<div class="bordLine"></div>
			<div class="mail"><img src="../../assets/ssjt/img/mail.jpg"> info@ssjt.cn</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Bottom"
}
</script>

<style scoped>
	@media (max-width: 767px){
		.bottom{ font-size: 12px; margin: auto; color: #93979a; }
		.con{ padding: 5px 10px 5px 10px; }
		.bord{ width: 90%; border-bottom: #434649 1px solid; }
		.tel{ font-size: 14px; }
		.bordLine{ width: 60%; border-bottom: #43484c dashed 1px; margin: 2px 0 2px 0; }
		.mail{ height: 16px; line-height: 16px; vertical-align: bottom; }
		.mail>img{ height: 15px; vertical-align: bottom; }
	}
	@media (min-width: 768px){
		.bottom{ padding-top: 20px; font-size: 16px; margin: auto; width: 1080px; color: #93979a; display: flex; justify-content: space-between; }
		.con{ width: 340px; height: 160px; }
		.bord{ width: 5px; height: 140px; border-left: #93979a 1px solid; }
		.tit{ height: 40px; margin-bottom: 10px; }
		.tel{ font-size: 28px; }
		.bordLine{ margin-top: 10px; margin-bottom: 12px; border-bottom: #93979a dashed 1px; }
		.mail{ height: 16px; line-height: 16px; vertical-align: bottom; }
		.mail>img{ height: 16px; vertical-align: bottom; }
	}
</style>